/* eslint-disable */
import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUpdateEffect, usePrevious } from 'react-use';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import qs from 'qs';
import { Popconfirm, Button, Avatar, Table, Divider, Breadcrumb, Tooltip } from 'antd';
import { withQuery } from '@/utils';
import * as actions from '@/models/employee/actions';
import * as selectors from '@/models/employee/selectors';
import { getTenantById } from '@/models/tenants/services';
import * as services from '@/models/tenants/services'
import { getCurrentUser } from '@/models/user/selectors';
import styles from './employees.module.scss';
import InvitationsDialog from '@/components/dialogs/InvitationsDialog';
import PageableTable from '@/components/PageableTable';
import EmployeeDialog from '@/components/dialogs/EmployeeDialog'

const appMode = process.env.APP_MODE;

function getColumns({ tenant, fetchList }) {
  const dispatch = useDispatch();
  const user = useSelector(getCurrentUser);
  const showManagerCreator = useCallback(({ title = "修改员工", row = {} }) => {
    dispatch(
      actions.showSaveDialog({
        title: title,
        isEdit: true,
        rowItem: row,
        submitCallback: () => {
          fetchList()
        }
      })
    );
  }, []);

  const changeAdmin = (row) => {
    services.changeAdmin({
      cstaffId: row._id
    }).then(res => {
      searchData()
      message.success('转让成功');
    }).catch(err => {
      message.error(err?.message || '转让失败');
    })
  };

  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => (
        <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
      ),
    },
    {
      title: '头像',
      render: (item) => (
        <Avatar shape="square" size={42} src={item?.user?.avatar} />
      ),
    },
    {
      title: '姓名',
      render: (item) => (
        <div>
          <div>{item?.user?.name}</div>
          <small style={{ color: '#b2b2b2' }}>{item?.realname}</small>
        </div>
      ),
    },
    {
      title: '注册手机',
      render: (item) => (
        <div>
          <div>{item?.user?.mobile}</div>
        </div>
      ),
    },
    {
      title: '所属公司',
      render: (item) => (
        <div>
          <div>{item?.tenant?.short_name}</div>
        </div>
      ),
    },
    {
      title: '近期登录时间',
      render: (item) => (
        <div>
          {item?.user?.lastLoginAt ? dayjs(item?.user?.lastLoginAt).fromNow() : '-'}
        </div>
      ),
    },
    {
      title: '状态',
      render: (item) => (
        <div style={{ color: item.isActive ? '#87d068' : '#CCC' }}>
          {item.isActive ? '正常' : '禁用'}
        </div>
      ),
    },
    {
      title: '添加时间',
      render: (item) => (
        <div>{dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</div>
      ),
    },
    {
      title: '操作',
      render: (item) => {
        const setActiveAction = () =>
          dispatch(actions.setActiveState(item._id, !item.isActive));
        const rolesHandler = () =>
          dispatch(
            actions.showStaffRolesDialog({
              title: '员工权限',
              id: item._id, // 员工id，非用户id
              permissions: item.permissions || [],
            })
          );
        const isOwner = tenant?.owner?._id !== item?.user?._id;

        return (
          <div>
            {isOwner ? (
              <a onClick={rolesHandler}>权限</a>
            ) : (
              <span style={{ color: '#a8a8a8', cursor: 'no-drop' }}>
                <Tooltip title="管理员具有最高权限">权限</Tooltip>
              </span>
            )}
            <Divider type="vertical" />
            <a onClick={setActiveAction}>
              {item.isActive ? '设为禁用' : '解除禁用'}
            </a>
            <Divider type="vertical" />
            <a onClick={() => { showManagerCreator({ title: "修改信息", row: item }) }}>修改信息</a>
            {item?.account_type == 2 && user.getIn(['staff',['account_type']]) ==1 && <>
            <Divider type="vertical" />
            <Popconfirm
              placement="topRight"
              title="确认转让管理员？"
              onConfirm={() => { changeAdmin(item) }}
            >
              <a>转让管理员</a>
            </Popconfirm>
          </>}
          </div>
        );
      },
    },
  ];
}

function Employees(props) {
  const dispatch = useDispatch();
  const { query, history, match, location } = props;
  const user = useSelector(getCurrentUser);
  const tenantId =
    props.tenantId || match.params.id || user.getIn(['staff', 'tenant', '_id']);
  const [tenant, setTenant] = useState(null);
  const prevQuery = usePrevious(query);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [queryParams, setQueryParams] = useState({});
  const loading = useSelector(selectors.loadingSelector);
  const total = useSelector(selectors.totalSelector);
  const employees = useSelector(selectors.entriesSelectors);
  const pagination = {
    showQuickJumper: true,
  };

  const fetchList = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setQueryParams(params)
    dispatch(actions.fetchList(tenantId, params));
  }, []);

  const showInfoDialog = useCallback(
    (title, tenantId) => () => {
      dispatch(
        actions.showInfoDialog({
          title,
          tenantId: tenantId,
        })
      );
    },
    []
  );

  const showEmployeeCreator = useCallback((title, tenantId) => {
    dispatch(
      actions.showSaveDialog({
        title: title,
        isEdit: false,
        tenantId: tenantId,
        submitCallback: () => {
          fetchList(query);
        }
      })
    );
  }, []);

  const handleTableChange = useCallback(
    (params) => {
      window.scrollTop = 0;
      const nextQuery = {
        ...query,
        ...params,
      };

      // let url;
      // if (appMode === 'tenant') {
      //   url = `/employees?${qs.stringify(nextQuery)}`;
      // } else {
      //   url = `/enterprises/${tenantId}/employees?${qs.stringify(nextQuery)}`;
      // }
      // history.push(url);
      fetchList(nextQuery)
    },
    [tenantId]
  );

  const columns = getColumns({ tenant, fetchList });

  useEffect(() => {
    getTenantById(tenantId).then((result) => setTenant(result));

    fetchList(query);
  }, [tenantId]);

  // useUpdateEffect(() => {
  //   if (prevQuery.offset !== query.offset) {
  //     window.scrollTop = 0;
  //     fetchList(query);
  //   }
  // });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Breadcrumb>
          {appMode !== 'tenant' && tenant && (
            <Breadcrumb.Item>
              {tenant.short_name || tenant.name}
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item>员工管理</Breadcrumb.Item>
        </Breadcrumb>
        <Button onClick={() => { showEmployeeCreator('添加员工', tenantId) }}>添加员工</Button>
        {/* <Button onClick={showInfoDialog('添加员工', tenantId)}>添加员工</Button> */}
      </div>
      <PageableTable
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={employees.toJS()}
        pagination={pagination}
        total={total}
        limit={+limit}
        offset={+offset}
        onChange={handleTableChange}
        loading={loading}
      />
      <EmployeeDialog />
      <InvitationsDialog type="staff" />
    </div>
  );
}

export default withQuery(Employees);
